import { useCallback, useEffect, useRef } from 'react';
import { useSetAtom } from 'jotai';
import type { UserFilterModel } from './types';
import { dashboardFilterAtom } from '../../filterAtom';

export const useUserFilter = (model: UserFilterModel | null) => {
  const setDashboardFilter = useSetAtom(dashboardFilterAtom);
  const previousModelReference = useRef<UserFilterModel | null>(null);

  const updateAtom = useCallback(
    (newModel: UserFilterModel | null) =>
      setDashboardFilter((previousFilter) => ({
        ...previousFilter,
        userIds:
          newModel?.userIds && newModel.userIds.length > 0
            ? newModel.userIds
            : null,
      })),
    [setDashboardFilter]
  );

  useEffect(() => {
    const currentUserIds = model?.userIds || [];
    const previousUserIds = previousModelReference.current?.userIds || [];

    const hasChanged =
      currentUserIds.length !== previousUserIds.length ||
      currentUserIds.some(
        (id: number, index: number) => id !== previousUserIds[index]
      );

    if (hasChanged) {
      updateAtom(model);
      previousModelReference.current = model;
    }
  }, [model, updateAtom]);
};
